// GosterGizle.js — GÖSTER / GİZLE DÜĞMESİ — TEK BİLEŞEN (5 Eki 2026)
//
// 🔑 Serkan (5 Eki 2026): tasarım **B** — *"bunu uygulama içindeki bütün hide show gibi belirsizlik arz eden düğmelere
//    yapalım"*. Stil `tasarim.gorunumDugmesiStili` (nötr kutu + mavi şerit + mavi yazı); ok işareti açık/kapalı durumu
//    söyler (▾ açık · ▸ kapalı). FTL LIMITS, FCL LIMITS, TRAINING bu bileşeni çizer; DUTY SHEET aynı stili CSS metniyle.
import React from 'react';
import { KUTU_SINIFI, gorunumDugmesiStili, acilirBaslikStili, secimKutusuStili } from './tasarim';
import IsaretKutusu from './IsaretKutusu';

export default function GosterGizle({ acik, onClick, gizle = 'HIDE', goster = 'SHOW', testid, style = null }) {
  return (
    <button type="button" className={KUTU_SINIFI} aria-expanded={!!acik} data-testid={testid}
            style={{ ...gorunumDugmesiStili(), ...(style || {}) }} onClick={onClick}>
      <span aria-hidden="true">{acik ? '▾' : '▸'}</span>{acik ? gizle : goster}
    </button>
  );
}

/** Görünüm düğmesinin YALNIZ işareti — tıklanan şey başka bir öğe olduğunda (başlık, kart) içine konur. */
export function GosterGizleIsareti({ acik, gizle = 'HIDE', goster = 'SHOW', style = null }) {
  return (
    <span style={{ ...gorunumDugmesiStili(), cursor: 'inherit', ...(style || {}) }}>
      <span aria-hidden="true">{acik ? '▾' : '▸'}</span>{acik ? gizle : goster}
    </span>
  );
}

/** AÇILIR BAŞLIK (tasarım Y): başlığın tamamı tıklanır; sağda ▸ SHOW / ▾ HIDE. */
export function AcilirBaslik({ acik, onClick, children, testid, gizle = 'HIDE', goster = 'SHOW', style = null }) {
  return (
    <button type="button" className={KUTU_SINIFI} aria-expanded={!!acik} data-testid={testid} onClick={onClick}
            style={{ ...acilirBaslikStili(acik), ...(style || {}) }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0, flexWrap: 'wrap' }}>{children}</span>
      <GosterGizleIsareti acik={acik} gizle={gizle} goster={goster} />
    </button>
  );
}

/** SEÇİM KUTUSU (switch, tasarım S1): çerçeveli kutu + işaret kutusu; ekran okuyucu için checkbox. */
export function SecimKutusu({ isaretli, onClick, children = null, testid, devreDisi = false, etiket = null, style = null }) {
  return (
    <button type="button" role="checkbox" aria-checked={!!isaretli} aria-label={etiket || undefined} disabled={devreDisi}
            className={KUTU_SINIFI} data-testid={testid} onClick={devreDisi ? undefined : onClick}
            style={{ ...secimKutusuStili(isaretli, devreDisi), ...(style || {}) }}>
      <IsaretKutusu isaretli={!!isaretli} boyut={14} />{children}
    </button>
  );
}
